import { Box, Container, Skeleton } from '@mui/material';

const LoadingSkeleton = () => {
  return (
    <Container>
      {/* Comparison Wrapper Skeleton */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "32px",
          width: "100%",
          maxWidth: "1200px",
          padding: "80px 16px",
        }}
      >
        {/* Header Skeleton */}
        <Box sx={{ width: "100%", maxWidth: "1200px", }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
              gap: "16px",
              marginBottom: "24px",
            }}
          >
            <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: "16px" }}>
              <Skeleton
                variant="text"
                width="40%"
                height={60}
                sx={{ borderRadius: "4px", bgcolor: "rgba(35, 114, 185, 0.1)" }}
              />
              <Skeleton
                variant="text"
                width="60%"
                height={60}
                sx={{ borderRadius: "4px", bgcolor: "rgba(35, 114, 185, 0.1)" }}
              />
            </Box>
            
            <Skeleton
              variant="rectangular"
              width={40}
              height={40}
              sx={{ borderRadius: "50%", bgcolor: "rgba(35, 114, 185, 0.1)" }}
            />
          </Box>
        </Box>

        {/* Content Skeleton */}
        <Box sx={{ display: "flex", gap: "32px", width: "100%" }}>
          {/* Left Column Skeleton */}
          <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: "16px" }}>
            <Skeleton
              variant="text"
              width="80%"
              height={30}
              sx={{ bgcolor: "rgba(35, 114, 185, 0.1)" }}
            />
            <Skeleton
              variant="text"
              width="60%"
              height={30}
              sx={{ bgcolor: "rgba(35, 114, 185, 0.1)" }}
            />
            <Skeleton
              variant="rectangular"
              width={200}
              height={50}
              sx={{ borderRadius: "6px", bgcolor: "rgba(244, 123, 39, 0.2)" }}
            />
          </Box>

          {/* Right Column Skeleton */}
          <Box sx={{ flex: 2, display: "flex", flexDirection: "column", gap: "42px" }}>
            {[1, 0, 0].map((idx) => (
              <Box
                key={idx}
                sx={{ display: "flex", alignItems: "center", gap: "16px" }}
              >
                <Skeleton
                  variant="rectangular"
                  width={80}
                  height={40}
                  sx={{ borderRadius: "4px", bgcolor: "rgba(35, 114, 185, 0.15)" }}
                />
                <Box sx={{ flex: 1, position: "relative" }}>
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={40}
                    sx={{
                      borderRadius: "4px",
                      bgcolor:
                        idx === 0
                          ? "rgba(35, 114, 185, 0.2)"
                          : "rgba(217, 230, 244, 0.5)",
                    }}
                  />
                  <Skeleton
                    variant="text"
                    width="40%"
                    height={20}
                    sx={{
                      position: "absolute",
                      bottom: -24,
                      left: 0,
                      bgcolor: "rgba(35, 114, 185, 0.1)",
                    }}
                  />
                </Box>
              </Box>
            ))}
            <Box sx={{ mt: 4, width: "100%" }}>
              <Skeleton
                variant="text"
                width="90%"
                height={20}
                sx={{ bgcolor: "rgba(127, 144, 151, 0.2)" }}
              />
              <Skeleton
                variant="text"
                width="85%"
                height={20}
                sx={{ bgcolor: "rgba(127, 144, 151, 0.2)" }}
              />
            </Box>
          </Box>

        </Box>

        {/* Disclaimer Skeleton */}

      </Box>
    </Container>
  );
};

export default LoadingSkeleton;
